import { Link } from "react-router-dom";
import { FadeUp } from "@/components/motion";
import { ArrowUpRight } from "lucide-react";
import { PATHWAYS } from "@/data/services";
import { PathwayCard } from "@/pages/ServicesIndex";

export default function ServicesSummary() {
  return (
    <section data-testid="services-summary" id="services" className="relative bg-[#141414] py-28 md:py-36 border-y border-[#27272A]">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <FadeUp className="mb-14 max-w-3xl">
          <p className="tracking-label text-[11px] uppercase font-body font-bold text-[#DFFF00] mb-6">Services</p>
          <h2 className="font-display font-bold tracking-tighter leading-[0.95] text-4xl md:text-6xl text-[#F8F8F5]">
            Two clear ways <span className="font-serif-accent font-light">we can help.</span>
          </h2>
          <p className="mt-6 font-body text-[18px] md:text-[20px] text-[#D4D4D8] leading-[1.6]">
            Whether you are looking for a job, changing direction or exploring a small business,
            we start with your professional pitch and agree the scope with you before any work begins.
          </p>
        </FadeUp>

        <div className="grid lg:grid-cols-2 gap-6">
          {PATHWAYS.map((p, i) => (
            <PathwayCard key={p.slug} p={p} delay={i * 0.08} />
          ))}
        </div>

        <FadeUp delay={0.15}>
          <p className="mt-10 font-body text-[18px] text-[#A1A1AA] leading-[1.6]">
            Sending an enquiry does not commit you to purchasing a service.{" "}
            <Link
              to="/services"
              data-testid="services-summary-more-link"
              className="text-[#DFFF00] hover:underline underline-offset-4 font-semibold inline-flex items-center gap-1"
            >
              Read more about both pathways <ArrowUpRight size={14} />
            </Link>
          </p>
        </FadeUp>
      </div>
    </section>
  );
}
